import React from 'react';
import AutoLoanMarketplaceModuleView from 'partial/OfferManager/modules/AutoLoanMarketplaceModule/AutoLoanMarketplaceModuleView';

const AutoPurchaseOcfModuleView = props => {
  return <AutoLoanMarketplaceModuleView {...props} />;
};

export default AutoPurchaseOcfModuleView;
